import { Component, OnInit, Input } from "@angular/core";
import { Client } from 'src/app/parametrage/core/model/client';
import { Fournisseur } from 'src/app/parametrage/core/model/fournisseur';
import { ClientService } from 'src/app/parametrage/core/service/client.service';
import { FournisseurService } from 'src/app/parametrage/core/service/fournisseur.service';

@Component({
  selector: 'app-info-complementaire',
  templateUrl: './info-complementaire.component.html',
  styleUrls: ['./info-complementaire.component.scss']
})
export class InfoComplementaireComponent implements OnInit {
  
  @Input() requestId: any;
  clients:Client[];
  fournisseurs:Fournisseur[];
  
  constructor(
    private _clientService: ClientService,
    private _fournisseurService: FournisseurService
  ) {}

  ngOnInit() {
    this.getClientsByRequestId(this.requestId);
    this.getFournisseursByRequestId(this.requestId);
  }

  getClientsByRequestId(requestId)
  {
      this._clientService.getClientsByRequestId(requestId)
      .subscribe(
            data => {
              this.clients =  data;
            },
            error => {
              console.log(error);
            });
  }

  getFournisseursByRequestId(requestId)
  {
    this._fournisseurService.getFournisseursByRequestId(requestId)
    .subscribe(
          data => {
            this.fournisseurs =  data;
          },
          error => {
            console.log(error);
          });
  }

}
